import AService from '@/services/AService'

const ENTITY_NAME = 'immediate-taggings';

export default class ImmediateTaggingService extends AService {
  async create(data) {
    const response = await this.http.post(`${this.baseUrl}/${ENTITY_NAME}`, data)
    return response.data
  }

  async get(id) {
    const response = await this.http.get(`${this.baseUrl}/${ENTITY_NAME}/${id}`)
    return response.data
  }

  async getAll(params) {
    const response = await this.http.get(`${this.baseUrl}/${ENTITY_NAME}`, {params})
    return response.data
  }
}
